import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FaExclamation as WarningIcon } from 'react-icons/fa';
import classNames from 'classnames';

import Button from '../../shared/button.component';
import Spinner from '../../shared/spinner.component';
import StatusBadge from '../../shared/statusBadge.component';
import FileUploadButton from '../../shared/fileUpload/fileUploadButton.component';
import { acceptedExcelFileExtensions } from '../../shared/fileUpload/constants';
import { connectionsTypes } from '../constants';
import { IsClientLocked } from '../../shared/clientLocked/IsClientLocked.component';
import { clientLockedMessages } from '../../shared/clientLocked/messages';
import { debouncedRebuildReactTooltip } from '../../shared/debouncedRebuildReactTooltip';

class FileUIConnectionForm extends PureComponent {
  static propTypes = {
    calculateProvisionsWithoutUploading: PropTypes.func.isRequired,
    calculateProvisionsForFTPConnection: PropTypes.func.isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    refreshStatus: PropTypes.func.isRequired,
    uploadTrialBalanceFile: PropTypes.func.isRequired,

    calculateProvisions: PropTypes.bool.isRequired,
    connection: PropTypes.shape({
      connName: PropTypes.string.isRequired,
      connType: PropTypes.string.isRequired,
    }),
    connStatusName: PropTypes.string,
    isUploading: PropTypes.bool.isRequired,
    lastUpdateTime: PropTypes.string,
    loadTrialBalances: PropTypes.bool.isRequired,
    proformaCalc: PropTypes.bool.isRequired,
    updatedOn: PropTypes.string,
    hasUploadPrivilege: PropTypes.bool,
    showCannotBeginProcessingModal: PropTypes.func.isRequired,
    isRefreshingStatus: PropTypes.bool,
    canLoadTrialBalanceAndCalculate: PropTypes.bool.isRequired,
    isInCurrentPeriod: PropTypes.bool.isRequired,
    tbIsLoaded: PropTypes.bool.isRequired,
  };

  beginProcess = event => {
    const {
      hasUploadPrivilege,
      loadTrialBalances,
      calculateProvisionsWithoutUploading,
      calculateProvisionsForFTPConnection,
      showCannotBeginProcessingModal,
    } = this.props;

    if (!hasUploadPrivilege) {
      showCannotBeginProcessingModal();
      event.preventDefault();
      return;
    }

    if (this.props.connection?.connType === connectionsTypes.FileFTP) {
      return calculateProvisionsForFTPConnection();
    }

    if (!loadTrialBalances) {
      calculateProvisionsWithoutUploading(event);
    }
  };

  render() {
    const {
      calculateProvisions,
      connection,
      connStatusName,
      isUploading,
      lastUpdateTime,
      loadTrialBalances,
      onCheckboxChange,
      refreshStatus,
      updatedOn,
      uploadTrialBalanceFile,
      proformaCalc,
      hasUploadPrivilege,
      isRefreshingStatus,
      canLoadTrialBalanceAndCalculate,
      isInCurrentPeriod,
      tbIsLoaded,
    } = this.props;

    const isFtpConnection = connection?.connType === connectionsTypes.FileFTP;

    return (
      <div>
        <div className="row">
          <div className="col-sm-8">
            <div className="form-group batch-provisions-form">
              {!isRefreshingStatus && isFtpConnection && isInCurrentPeriod
                ? (
                  <IsClientLocked
                    onChange={debouncedRebuildReactTooltip}
                    render={isClientLocked => ( // eslint-disable-line react/jsx-no-bind
                      <>
                        <input
                          className="batch-provision-checkbox"
                          disabled={isUploading || !hasUploadPrivilege || isClientLocked}
                          type="checkbox"
                          name="proformaCalc"
                          onChange={onCheckboxChange}
                          checked={proformaCalc}
                        />
                        <label
                          htmlFor="calculateProvisions"
                          className={classNames({ 'text-muted': isClientLocked })}
                        >
                          {
                            isClientLocked && <WarningIcon
                              className="text-warning"
                              data-tip={clientLockedMessages.PROFORMA_CALC}
                            />
                          }
                          Proforma Calculation
                        </label>
                      </>
                    )}
                  />
                ) : null}
              {!isRefreshingStatus && !isFtpConnection && canLoadTrialBalanceAndCalculate
                ? (
                  <>
                    <input
                      className="batch-provision-checkbox"
                      disabled={isUploading || !hasUploadPrivilege}
                      type="checkbox"
                      name="loadTrialBalances"
                      onChange={onCheckboxChange}
                      checked={loadTrialBalances}
                    />
                    <label htmlFor="calculateProvisions">
                      Load Trial Balances
                    </label>
                    <input
                      className="batch-provision-checkbox"
                      disabled={!hasUploadPrivilege || (!loadTrialBalances && !tbIsLoaded)}
                      type="checkbox"
                      name="calculateProvisions"
                      onChange={onCheckboxChange}
                      checked={calculateProvisions}
                    />
                    <label htmlFor="calculateProvisions">
                      Calculate Provisions
                    </label>
                  </>
                ) : null}
            </div>
          </div>
          <div className="col-sm-4">
            {
              isRefreshingStatus
                ? (
                  <div className="status-loading-placeholder">
                    <Spinner className="d-flex spinner-no-margin mr-2" small />
                    Loading status
                  </div>
                )
                : (
                  <div className="batch-provision-status">
                    { connStatusName ? <StatusBadge value={connStatusName} /> : null}
                    {updatedOn && <p className="batch-provision-last-update">Last update: {lastUpdateTime}</p>}
                  </div>
                )
            }
          </div>
        </div>
        <div className="row">
          <div className="ml-auto col-8">
            <div className="batch-provision-begin-button">

              {!isRefreshingStatus && loadTrialBalances && canLoadTrialBalanceAndCalculate ? (
                <FileUploadButton
                  accept={acceptedExcelFileExtensions}
                  disabled={isUploading || !connection}
                  onChange={uploadTrialBalanceFile}
                  onClick={this.beginProcess}
                  isLoading={isUploading}
                >
                  Begin Process
                </FileUploadButton>
              ) : null}
              {!isRefreshingStatus && !loadTrialBalances && (canLoadTrialBalanceAndCalculate || isFtpConnection) ? (
                <Button
                  type="button"
                  kind="primary"
                  isLoading={isUploading}
                  onClick={this.beginProcess}
                  disabled={isUploading || !connection}
                >
                  Begin Process
                </Button>
              ) : null}
            </div>
          </div>

          <div className="ml-auto col-4">
            <div className="batch-provision-buttons">
              <Button
                type="button"
                kind="secondary"
                onClick={refreshStatus}
                disabled={!connection || isRefreshingStatus}
              >
                Refresh Status
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FileUIConnectionForm;
